import { gql } from '@apollo/client';

const UPDATE_BOOKING_REVIEW_STATUS = gql`
  mutation UPDATE_BOOKING_REVIEW_STATUS($id: String!, $status: String!) {
    review: update_logs_review_message_record(
      where: { booking_id: { _eq: $id } }
      _set: { review_status: $status }
    ) {
      returning {
        reviewStatus: review_status
      }
    }
  }
`;
export const FETCH_BOOKING_REVIEW= gql`
query FETCH_BOOKING_REVIEW($id: String!) {
  review: logs_review_message_record(where: { booking_id: { _eq: $id } }) {
    reviewStatus: review_status
  }
}
`

interface UPDATE_BOOKING_REVIEW_STATUS_INTERFACE {
  review: {
    returning: [
      {
        reviewStatus: REVIEW_STATUS_ENUM;
      }
    ];
  };
}
interface UPDATE_BOOKING_REVIEW_STATUS_INTERFACE {
  review: {
    returning: [
      {
        reviewStatus: REVIEW_STATUS_ENUM;
      }
    ];
  };
}
enum REVIEW_STATUS_ENUM {
  GOOGLE_REVIEW = 'GOOGLE_REVIEW',
  WEBSITE_FEEDBACK = 'WEBSITE_FEEDBACK',
  PENDING = 'PENDING'
}
export default UPDATE_BOOKING_REVIEW_STATUS;
export type { UPDATE_BOOKING_REVIEW_STATUS_INTERFACE };
